'use client'

import { HeroSection } from './HeroSection'
import { StoriesSection } from './StoriesSection'
import { QuotesSection } from './QuotesSection'
import { ThinkingSection } from './ThinkingSection'
import { BuildingBlocksSection } from './BuildingBlocksSection'
import { IntegrationsSection } from './IntegrationsSection'
import { FitSection } from './FitSection'
import { LandingCTASection } from './LandingCTASection'

export const LandingPage = () => {
  return (
    <>
      <HeroSection />
      <StoriesSection />
      <QuotesSection />
      <ThinkingSection />
      <BuildingBlocksSection />
      <IntegrationsSection />
      <FitSection />
      <LandingCTASection />
    </>
  )
}
